import { render, staticRenderFns } from "./RatingScale.vue?vue&type=template&id=50646109&scoped=true&"
import script from "./RatingScale.vue?vue&type=script&lang=js&"
export * from "./RatingScale.vue?vue&type=script&lang=js&"
import style0 from "./RatingScale.vue?vue&type=style&index=0&id=50646109&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50646109",
  null
  
)

export default component.exports